<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12">
      <p-table #dt
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0"
        [loading]="emergencyNumberService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true" 
        [value]="emergencyNumberService.emergencyNumbers"
        pDroppable="row">
        
        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                Números de emergencia
              </div>
              <div class="col-8 text-end">
                <button (click)="open()" class="btn btn-success rounded-circle me-2">
                  <i class="material-icons mt-1">add</i>
                </button>
                <button (click)="emergencyNumberService.getAll(neighborhoodId!)" class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">refresh</i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="phoneNumber">
              Número
              <p-sortIcon field="phoneNumber"></p-sortIcon>
              <p-columnFilter type="text" field="phoneNumber" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="description">
              Descripción
              <p-sortIcon field="description"></p-sortIcon>
              <p-columnFilter type="text" field="description" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="showed">
              Estatus
              <p-sortIcon field="showed"></p-sortIcon>
            </th>

            <th>Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-emergencyNumber>
          <tr class="p-selectable-row">
            <td>
              <span class="p-column-title">Número</span>
              {{emergencyNumber.phoneNumber}}
            </td>

            <td>
              <span class="p-column-title">Tipo</span>
              {{emergencyNumber.description}}
            </td>

            <td>
              <span class="p-column-title">Estatus</span>
              <!-- {{brand.status}} -->
              <p-inputSwitch
                (onChange)="update(emergencyNumber)"
                [(ngModel)]="emergencyNumber.status">
              </p-inputSwitch>
            </td>

            <td>
              <button (click)="open(emergencyNumber)" class="btn btn-sm btn-light rounded-circle me-2">
                <i class="material-icons mt-1">edit</i>
              </button>
              <button (click)="delete(emergencyNumber)" class="btn btn-sm btn-danger rounded-circle">
                <i class="material-icons mt-1">delete</i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
